import { zodResolver } from '@hookform/resolvers/zod';

import { UseFormProps, UseFormReturn, useForm, useFormContext } from 'react-hook-form';
import { z } from 'zod';

/** Use this hook if you're getting type errors on defaultValues or onSubmit data */
export function useZodForm<Schema extends z.ZodTypeAny, Context = unknown>(
  props: Exclude<UseFormProps<z.input<Schema>, Context>, 'resolver'> & {
    schema: Schema;
  },
): UseFormReturn<z.input<Schema>, Context, z.infer<Schema>> {
  return useForm<z.input<Schema>, Context, z.infer<Schema>>({
    ...props,
    resolver: zodResolver(props.schema),
  });
}

export const useZodFormContext = <Schema extends z.ZodTypeAny>() =>
  useFormContext<z.input<Schema>, unknown, z.infer<Schema>>();
